import { useState } from "react";
import { Zap } from "lucide-react";
import { Button } from "./ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogTrigger,
} from "./ui/dialog";
import TodaySchedule from "./TodaySchedule";
import { todayDay } from "../lib/schedule";

export default function QuickLogModal({ triggerClassName, triggerLabel = "Log Today's Attendance" }) {
    const [open, setOpen] = useState(false);
    const day = todayDay();

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    className={
                        triggerClassName ||
                        "rounded-xl bg-ink hover:bg-ink/90 text-white font-bold h-12 px-6 shadow-md"
                    }
                    data-testid="open-quick-log-btn"
                >
                    <Zap
                        size={18}
                        strokeWidth={2.8}
                        className="mr-2 text-[#3D6385] fill-[#3D6385]"
                    />
                    {triggerLabel}
                </Button>
            </DialogTrigger>
            <DialogContent
                className="max-w-3xl rounded-3xl p-0 overflow-hidden max-h-[90vh] flex flex-col"
                data-testid="quick-log-modal"
            >
                <DialogHeader className="px-6 sm:px-8 pt-6 pb-4 border-b border-mist bg-gradient-to-br from-action-soft to-white">
                    <DialogTitle className="font-display font-bold text-2xl uppercase tracking-tight">
                        Quick Log · {day}
                    </DialogTitle>
                    <DialogDescription className="text-sm text-slate-600">
                        Tap a status to log today’s attendance instantly. Changes save
                        immediately and update your dashboard.
                    </DialogDescription>
                </DialogHeader>
                <div className="px-6 sm:px-8 py-4 overflow-y-auto">
                    <TodaySchedule compact />
                </div>
                <div className="px-6 sm:px-8 py-4 border-t border-mist flex justify-end bg-mist/50">
                    <Button
                        onClick={() => setOpen(false)}
                        className="rounded-xl bg-[#3D6385] hover:bg-[#345570] text-white font-bold h-11 px-5"
                        data-testid="quick-log-done-btn"
                    >
                        Done
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
